import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const Billing_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/billings',
        iconClass: 'fas fa-credit-card',
        name: '::Menu:Billing',
        layout: eLayoutType.application,
        requiredPolicy: 'Ldm.Billing',
      },
    ]);
  };
}
